import ManageAccountsOutlined from '@mui/icons-material/ManageAccountsOutlined'
import Menu from '@mui/icons-material/Menu'
import QueryStatsOutlined from '@mui/icons-material/QueryStatsOutlined'
import AppBar from '@mui/material/AppBar'
import IconButton from '@mui/material/IconButton'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import { useAtomValue } from 'jotai'
import { Suspense, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router'
import logo from '../../assets/snj-logo.png'
import { isDevEnv } from '../../lib/env'
import { Path } from '../../routeConfig'
import { hasAdminAccessAtom } from '../state'
import AppBarButton from './header/AppBarButton'
import HelpMenu from './header/HelpMenu'
import LanguageMenu from './header/LanguageMenu'
import UserMenu from './header/UserMenu'

interface Props {
  readonly toggleMenu?: () => void
}

const Header = ({ toggleMenu }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const hasAdminAccess = useAtomValue(hasAdminAccessAtom)
  const location = useLocation()
  const inAdmin = !!toggleMenu
  const headerBackgroundColor = isDevEnv() ? '#08821f' : undefined

  const handleHomeClick = useCallback(() => navigate(Path.home), [navigate])
  const handleAdminClick = useCallback(() => navigate(Path.admin.root), [navigate])
  const handleStatsClick = useCallback(() => navigate(Path.stats), [navigate])

  return (
    <AppBar position="fixed" elevation={0} sx={{ bgcolor: headerBackgroundColor }}>
      <Toolbar variant="dense" disableGutters sx={{ height: 36, minHeight: 36, px: 1, width: '100%' }}>
        {toggleMenu ? (
          <IconButton color="secondary" sx={{ display: { md: 'none', sm: 'inline-flex' } }} onClick={toggleMenu}>
            <Menu />
          </IconButton>
        ) : null}
        <AppBarButton
          active={hasAdminAccess && !inAdmin}
          startIcon={
            <img
              src={logo}
              width="20"
              height="28"
              alt="Suomen noutajakoirajärjestö"
              style={{ marginBottom: '-4px', marginTop: '-4px' }}
            />
          }
          label="home"
          onClick={handleHomeClick}
        >
          Koekalenteri
        </AppBarButton>
        {hasAdminAccess ? (
          <AppBarButton
            active={inAdmin}
            startIcon={<ManageAccountsOutlined />}
            onClick={handleAdminClick}
            label="admin"
          >
            {t('admin')}
          </AppBarButton>
        ) : null}
        {hasAdminAccess ? (
          <AppBarButton
            active={location.pathname === Path.stats}
            startIcon={<QueryStatsOutlined />}
            onClick={handleStatsClick}
            label="stats"
          >
            {t('stats.title')} {t('stats.beta')}
          </AppBarButton>
        ) : null}
        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{
            color: '#fdfdfd',
            flexGrow: 1,
            flexShrink: 10000,
            ml: 1,
          }}
        ></Typography>
        <Suspense>
          <LanguageMenu />
          <UserMenu />
          <HelpMenu />
        </Suspense>
      </Toolbar>
    </AppBar>
  )
}

export default Header
